import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Setup Points Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> This is the first step in solving Vehicle Routing Problems (VRP). Set up customer location points and configure vehicle parameters for multi-vehicle route optimization.</p>
          
          <p><strong>Three Ways to Add Points:</strong></p>
          
          <p><strong>Method 1: Map Point Marking</strong></p>
          <ol>
            <li>Click "Map Point Marking" tab (default mode)</li>
            <li>Click directly on the map to add customer locations</li>
            <li>Points are automatically numbered sequentially</li>
            <li>Continue clicking to add all customer locations</li>
          </ol>

          <p><strong>Method 2: Manual Input</strong></p>
          <ol>
            <li>Click "Manual Input" tab</li>
            <li>Enter precise latitude and longitude coordinates</li>
            <li>Click "Add" button to create the point</li>
            <li>Useful for exact coordinate placement</li>
          </ol>

          <p><strong>Method 3: Load Points</strong></p>
          <ol>
            <li>Click "Load Points" button</li>
            <li>Select a JSON/GeoJSON/CSV file</li>
            <li>System imports and validates all points</li>
            <li>Best for loading existing configurations</li>
          </ol>

          <p><strong>Set Depot (Start Point):</strong></p>
          <ul>
            <li>Click "S" button next to any point to set as depot</li>
            <li>Depot is where all vehicle routes begin and end</li>
            <li>All vehicles start from and return to depot</li>
            <li>Setting depot is required for routing</li>
          </ul>

          <p><strong>Configure Vehicle Capacity:</strong></p>
          <ul>
            <li>Set maximum capacity per vehicle if needed</li>
            <li>Capacity constraint affects route optimization</li>
            <li>Set to 0 for unlimited capacity</li>
          </ul>

          <p><strong>Manage Points:</strong></p>
          <ul>
            <li>View all added points in Location Points list</li>
            <li>Edit point names by clicking on them</li>
            <li>Delete unwanted points using × button</li>
            <li>Download configuration to save your work</li>
            <li>Reset to clear all points and start over</li>
          </ul>

          <p><strong>VRP Key Concepts:</strong></p>
          <ul>
            <li><strong>VRP (Vehicle Routing Problem):</strong> Optimize routes for multiple vehicles serving customers</li>
            <li><strong>Depot:</strong> Central location where all vehicles start and end</li>
            <li><strong>Customer Points:</strong> Locations that need to be visited by vehicles</li>
            <li><strong>Vehicle Fleet:</strong> Multiple vehicles work together to serve all customers</li>
          </ul>

          <p><strong>Complete VRP Workflow:</strong></p>
          <ol>
            <li><strong>Step 1: Setup Points (Current)</strong> - Add customer locations, set depot, configure capacity</li>
            <li><strong>Step 2a: Auto Find Path</strong> - Use algorithms to optimize multi-vehicle routes</li>
            <li><strong>Step 2b: Custom Path</strong> - Manually design routes for each vehicle</li>
            <li><strong>Step 3: Compare Mode</strong> - Compare auto vs manual multi-vehicle solutions</li>
          </ol>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Minimum 3 points required (1 depot + 2+ customers)</li>
            <li>More customers = more complex routing problem</li>
            <li>Vehicle capacity affects how routes are distributed</li>
            <li>Use descriptive names for easy identification</li>
            <li>Save configuration regularly using Download</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 